"use client";
import { useRef } from "react";
export function useGlobalSearchParams(_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.allowCookies, allowCookies = _c === void 0 ? false : _c;
    var stateRef = useRef({
        campaign: "",
    });
    return [
        stateRef.current,
        {
            clearCampaign: function () { },
        },
    ];
}
